import {axios} from '../../services/axios';

export default async function updateApprovalCode(params) {
    return axios
        .put(`/ApprovalCode`, params)
        .then((res) => res)
        .catch((e) => e);
}
